// ============================================================
// API base URL resolver.
//
// In PRODUCTION (running on the same domain as the backend),
// using a hardcoded REACT_APP_BACKEND_URL is fragile because the
// build-time variable can point to www.rebelbtc.com while the
// runtime origin is apex rebelbtc.com (or vice versa). That
// mismatch triggers a 308 cross-subdomain redirect, which
// browsers refuse to follow during CORS preflight → all
// authenticated fetches fail with "Failed to fetch".
//
// Resolution order (runtime-first):
//   1. If served from a *.rebelbtc.com host, always use the
//      current window.location.origin → same-origin, no CORS.
//   2. Otherwise, fall back to process.env.REACT_APP_BACKEND_URL
//      so the preview environment keeps pointing at the
//      polyglot-trendia-web.preview.emergentagent.com backend.
//
// The /api suffix is appended for callers via apiUrl().
// ============================================================

const getApiBase = () => {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    const host = window.location.hostname || "";
    if (host.endsWith("rebelbtc.com")) {
      return window.location.origin;
    }
  }
  // Preview / SSR / non-prod fallback
  return process.env.REACT_APP_BACKEND_URL || "";
};

export const API_BASE = getApiBase();
export const API = `${API_BASE}/api`;

// =============================================================
// safeJson — read a Response body defensively.
//
// PostHog session-replay (and other 3rd-party fetch interceptors)
// can consume the body stream of a Response before our code gets to
// it, triggering: "Failed to execute 'json' on 'Response': body stream
// already read". Using res.clone() leaves the original stream intact
// for any interceptor and gives us a fresh stream to parse.
//
// Always prefer:   const data = await safeJson(res);
// Instead of:      const data = await res.json();
// =============================================================
export async function safeJson(res) {
  try {
    return await res.clone().json();
  } catch {
    try {
      const txt = await res.clone().text();
      return txt ? JSON.parse(txt) : null;
    } catch {
      return null;
    }
  }
}

export default API;
